<template>
  <div class="app-divider" />
</template>

<script>
export default {
  name: 'AppDivider'
}
</script>

<style scoped>
.app-divider {
  width: 31.19rem;
  flex-shrink: 0;
  flex-grow: 0;
  border-top: 1px solid #ff8511;
  height: 0.6rem;
  margin: 1rem 0;
}
</style>
